import { Method, Request, sendRequest } from "@myloc/myloc-utils";
import { api } from "../../config/settings";
import defaultRestOptions from "../utils/defaultRestOptions";
import { AbsencePayload } from "./types";

async function getAbsence() {
  const url = api.account.absence();
  const request = new Request(url, Method.GET);

  return await sendRequest(request, {}, await defaultRestOptions());
}

async function updateAbsence(data: AbsencePayload) {
  const url = api.account.absence();
  const request = new Request(url, Method.PUT);

  return await sendRequest(request, data, await defaultRestOptions());
}

export default {
  getAbsence,
  updateAbsence,
};
